import React from "react";
import moment from "moment";
import {component_tool} from "../../../../tool"

const {WizModal, WizDivider, WizRadio, WizRow, WizCol, WizTooltip, WizIcon} = component_tool
const formatterDate = (val) => {
  return val ? moment(val).format('YYYY-MM-DD HH:mm') : '';
}

const _getValue = (type, key) => {
  const values = {
    type: {
      0: "通用",
      1: "班级",
      // 2: "活动"
    },
    state: {
      0: '无效',
      1: '有效'
    }
  };
  return values[type][key]
}

export default (self, values, planType,updateType,limitNum,applyNumber) => {
  let disable = false
  let maxVar = 999999999
  let minVar = -1
  if(planType === 1) {
    disable = true
    if(updateType === 'update') {
      maxVar = limitNum
      if (applyNumber > 0) {
        minVar = applyNumber
      }
    }
  }

  return [
    {
      title: "计划安排名称",
      dataIndex: "name",
      key: "name",
      name: "name",
      formItem: {
        maxLength: 30,
        message: "计划安排名称不能超过30个字符",
        rules: [
          {
            required: true,
            message: "计划安排名称必填"
          },
          // {
          //   pattern: /^[^\s]*$/,
          //   message: "计划安排名称录入信息不能包含空格"
          // }
        ],
        initialValue: values && values.name,
        disabled: values && values.name && (values.type === 2 || values.type === 1) ? true : false
      }
    },
    {
      title: "计划安排类型",
      dataIndex: "type",
      key: "type",
      name: "type",
      render: (text) => {
        return _getValue("type",text)
      }
    },
    {
      title: "计划安排时间",
      dataIndex: "applyPlanTime",
      key: "applyPlanTime",
      name: "applyPlanTime",
      formItem: {
        type: "date~",
        rules: [
          {
            required: true,
            message: "时间必填"
          }
        ],
        showTime: {format: 'HH:mm'},
        format: 'YYYY-MM-DD HH:mm',
        initialValue: values && values.startTime && [moment(values.startTime), moment(values.endTime)],
        disabled: values && values.startTime && (values.type === 2 || values.type === 1) ? true : false
      },
      render: (text, record) => {
        const {startTime, endTime} = record;
        return formatterDate(startTime) + " ~ " + formatterDate(endTime)
      }
    },
    {
      title: "地址",
      dataIndex: "address",
      key: "address",
      name: "address",
      formItem: {
        ellipsis: true,
        // maxLength: 200,
        rules: [
          {
            required: !disable,
            message: "地址必填"
          }
        ],
        initialValue: values && values.address,
        disable:{disable}
      },
    },
    {
      title: "报名时间限制",
      dataIndex: "applyTimeStr",
      key: "applyTimeStr",
      name: "applyTimeStr",
      /* formItem: {
        ellipsis: true,
        // maxLength: 200,
        rules: [
          {
            required: !disable,
            message: "报名时间限制必填"
          }
        ],
        initialValue: values && values.applyTimeStr,
        disable: false,
      }, */
    },
    {
      name: "id",
      key: "id",
      formItem: {
        type: "hidden",
        initialValue: values && values.id
      }
    },
    {
      name: "_id",
      key: "_id",
      formItem: {
        type: "hidden",
        initialValue: values && values._id
      }
    },
    {
      name: "entityId",
      key: "entityId",
      formItem: {
        type: "hidden",
        initialValue: values && values.entityId
      }
    },
    {
      title: "限制人数",
      dataIndex: "limitCount",
      key: "limitCount",
      name: "limitCount",
      formItem: {
        type: 'number',
        placeholder: '-1表示不限制',
        min: minVar,
        max: maxVar,
        rules: [
          {
            required: true,
            message: "限制人数必填,-1表示不限制"
          }
        ],
        initialValue: values && values.limitCount
      },
    },
    {
      title: "安排状态",
      dataIndex: "state",
      key: "state",
      name: "state",
      formItem: {
        type: 'custom',
        render: (record, form) => {
          let {state} = values
          state = state == 0 ? 0 : 1;
          const { getFieldDecorator } = form;
          return (<>
              <WizRow>
                <WizCol>
                  {getFieldDecorator('state', {
                    initialValue: state,
                  })(
                    <WizRadio.Group
                      key={'state'}
                      options={[{ label: '有效', value: 1 }, { label: '无效', value: 0 }]}
                      value={state}
                      disabled={disable}
                    />)}
                </WizCol>
              </WizRow>
            </>
          )
        }
      },
      render: (text) => {
        return _getValue("state",text)
      },
    },
    {
      title: "操作",
      dataIndex: "action",
      key: "action",
      render: (text, record) => {
        let changeState =  record['state'] === 0 ? 1 : 0
        let changeStateName =  record['state'] === 0 ? "启用" : "禁用"
        const content = `您确定要${changeStateName}该计划安排吗？`;
        return (
          <span>
            {self._buttonGroup(record)}
            <a onClick={e => {
              WizModal.confirm({
                title: content,
                onOk: () => {
                  self._changeRow(record, changeState)
                },
                onCancel() {
                }
              });
            }
            }>{changeStateName}</a>
            <WizDivider type="vertical"/>
            <a onClick={e => {
              if (record && record.applyNumber > 0) {
                wizNotice.error("该计划安排已有报名人员，不能删除")
              } else {
                WizModal.confirm({
                  title: '您确定删除该计划安排么？',
                  onOk: () => {
                    self._removeRow(record)
                  },
                  onCancel() {
                  }
                });
              }
            }
            }>删除</a>
          </span>
        )
      }
    }
  ]
}
